/** Actions are fire-and-forget: anything async must handle its own rejection. */
type Action = () => void;

export class ActionQueue {
    private actions: Action[] = [];

    public enqueue(action: Action): void {
        this.actions.push(action);
    }

    public resolve(): void {
        for (let action = this.actions.shift(); action; action = this.actions.shift()) {
            action();
        }
    }
}
